import { Form, Input, TooltipProps } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import {
  InputMaskOptions,
  MaskType,
} from 'antd-mask-input/build/main/lib/MaskedInput';
import React, { ComponentProps, ReactElement, ReactNode } from 'react';
import { Control, Controller as ControllerHookForm } from 'react-hook-form';

import { toFieldStatus } from 'src/app/utils/toFieldStatus';
const { Item: FormItem } = Form;

interface ControllerProps extends ComponentProps<typeof Input> {
  name: string;
  mask: MaskType;
  maskOptions?: InputMaskOptions;
  control?: Control<any>;
  placeholder?: string;
  defaultValue?: string;
  autoComplete?: string;
  prefix?: React.ReactNode;
  type?: string;
  label?: string;
  required?: boolean;
  maxLength?: number;
  addonAfter?: React.ReactNode;
  disabled?: boolean;
  showCount?: boolean;
  tooltip?: ReactNode | (TooltipProps & { icon?: ReactElement });
}

export const MaskedInputController: React.FC<ControllerProps> = ({
  control,
  defaultValue,
  name,
  mask,
  maskOptions,
  placeholder,
  autoComplete,
  prefix,
  type,
  label,
  required,
  maxLength,
  addonAfter,
  disabled,
  showCount,
  tooltip,
  ...rest
}) => {
  return (
    <ControllerHookForm
      control={control}
      name={name}
      defaultValue={defaultValue ? defaultValue : undefined}
      render={({ field, fieldState }) => {
        const { status, help } = toFieldStatus(fieldState.error);

        return (
          <FormItem
            required={required}
            validateStatus={status}
            help={help}
            label={label}
            {...(maxLength &&
              !showCount && { extra: `(${maxLength} caracteres no máximo)` })}
            {...(tooltip && { tooltip: tooltip })}
          >
            <MaskedInput
              {...rest}
              {...field}
              name={name}
              aria-label={label}
              mask={mask}
              maskOptions={maskOptions}
              placeholder={placeholder}
              data-testid={name}
              type={type}
              autoComplete={autoComplete}
              prefix={prefix}
              addonAfter={addonAfter}
              disabled={disabled}
              {...(maxLength && { maxLength: maxLength })}
              {...(showCount && { showCount })}
            />
          </FormItem>
        );
      }}
    />
  );
};
